module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kj-Lc.797ace0d.png";